module.exports = __webpack_public_path__ + "assets/img/kjdspt-bj1.e7699010.png";